import { inject, Injectable } from '@angular/core';
import { TemporaryLoggerService } from '../temporary-logger/temporary-logger.service';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

@Injectable()
export class GlobalErrorHandler extends BugsnagErrorHandler {
  tempLoggerService = inject(TemporaryLoggerService);

  constructor() {
    super();
  }

  override handleError(error: Error): void {
    super.handleError(error);
    this.tempLoggerService.log('Global Error Handler', error.toString());
  }
}
